<template>
  <div class="flex w-full flex-col items-center justify-end">
    <IconButton
      class="flex self-end"
      name="ic-x"
      :c_style="{ type: 'tertiary' }"
      @click="$emit('close')"
    />

    <div class="flex max-w-[32rem] flex-col gap-5 font-secondary">
      <h1
        class="font-bold leading-[100%] text-neutral-900"
        :class="{
          'text-size_5': type === 'feedback',
          'text-size_6': type === 'confirmation',
        }"
      >
        {{
          type === "feedback"
            ? "You are about to request account deletion"
            : "Your Request is now submitted"
        }}
      </h1>

      <p class="font-secondary font-medium leading-[22px] text-neutral-700">
        We're sorry to see you leave. We will contact you as soon as possible to
        confirm deletion.
        {{
          type === "feedback"
            ? ` Please help us improve by telling us why are you leaving. we'd
            really appreciate your feedback. to confirm deletion.`
            : ""
        }}
      </p>
    </div>
  </div>

  <div v-if="type === 'feedback'" class="flex flex-col gap-2.5">
    <p class="text-size_5 font-bold">Tell us why you're leaving:</p>
    <Textarea
      v-model="message"
      id="account-deletion-feedback"
      class="min-h-32"
      name="message"
      placeholder="Write your message.."
    />

    <CommonMessage
      v-if="error"
      prefix_icon="ic-info"
      :error="!!error"
      :message="error"
    />
  </div>

  <Button
    class="w-full"
    :label="type === 'feedback' ? 'Submit' : 'Close'"
    :loading="loading"
    :disabled="type === 'feedback' && !message.trim()"
    @click="type === 'feedback' ? $emit('submit') : $emit('close')"
  />
</template>

<script setup lang="ts">
import IconButton from "~/components/common/Atom/IconButton.vue";
import Textarea from "~/components/common/Atom/Textarea.vue";
import CommonMessage from "~/components/common/Atom/Message.vue";
import Button from "~/components/common/Atom/Button.vue";

withDefaults(
  defineProps<{
    type: "confirmation" | "feedback";
    loading: boolean;
    error?: string;
  }>(),
  { type: "feedback" },
);

const emit = defineEmits(["submit", "close"]);

const message = defineModel("message", { default: "" });
</script>
